<template>
    <k-page background="bg-white">
        <template v-slot:header>
            <profile-header/>
        </template>
        <k-container class="py-10">
            <div class="max-w-3xl mx-auto">
                <h1 class="text-3xl font-bold mb-8">{{ $t("investorVerification") }}</h1>
                <div v-if="step === 'intro'">
                    <div class="bg-white py-3 mb-8 text-justify">
                        <h3 class="font-semibold mb-3">{{ $t("accreditedInvestorVerification") }}</h3>
                        <p class="mb-3">{{ $t("accreditedInvestorVerificationDesc") }}</p>

                        <p class="mb-6">{{ $t("accreditedInvestorVerificationDesc2") }}</p>

                        <h3 class="font-semibold mt-8 mb-3">{{ $t("income") }}</h3>
                        <p class="mb-3">
                            {{ $t("incomeDesc") }}
                        </p>

                        <h3 class="font-semibold mt-8 mb-3">{{ $t("financialAssets") }}</h3>
                        <p class="mb-3">
                            {{ $t("financialAssetsDesc") }}
                        </p>

                        <h3 class="font-semibold mt-8 mb-3">{{ $t("personalAssets") }}</h3>
                        <p class="mb-3">
                            {{ $t("personalAssetsDesc") }}
                        </p>
                        <p>{{ $t("informationComplete") }}</p>
                    </div>
                    <k-button @click="proceed">{{ $t("proceed") }}</k-button>
                </div>
                <div v-if="step === 'questionnaire'">
                    <questionnaire-form
                        :validation="validation"
                        @submit="onSubmit"
                    />
                </div>
                <div v-if="step === 'accepted'">
                    <opt-in-as-accredited-investor/>
                    <div class="mt-5">
                        <a-button type="primary" @click="confirmQuestionnaire">
                            {{ $t("agree") }}
                        </a-button>
                    </div>
                </div>
                <div v-if="step === 'thank-you'">
                    <p class="mb-3">
                        <strong>{{ $t("thankYou") }}</strong>
                    </p>
                    <p class="mb-3">
                        {{
                            $t("teamWillContact")
                        }}
                    </p>
                    <p class="mb-3">
                        {{ $t("documentationExamplesDesc") }}
                    </p>
                    <ul class="list-disc ml-8 mb-6">
                        <li>{{ $t("paySlips") }}</li>
                        <li>{{ $t("bankStatements") }}</li>
                        <li>{{ $t("investmentStatements") }}</li>
                        <li>{{ $t("lifePolicy") }}</li>
                        <li>{{ $t("financialStatementsDesc") }}</li>
                        <li>{{ $t("excerptFromLand") }}</li>
                    </ul>
                    <a-button type="primary" @click="finish">
                        {{ $t("ok") }}
                    </a-button>
                </div>
                <div v-if="step === 'rejected'">
                    <p class="mb-3">
                        <strong>{{ $t("unableToConfirmAccredited") }}</strong>
                    </p>
                    <p class="mb-3">
                        {{ $t("thankYouForInterest") }}
                    </p>
                    <p class="pb-6 mb-6 border-b">
                        {{ $t("registrationNotPossible") }}
                    </p>
                    <div class="mt-2 w-auto flex flex-wrap justify-between">
                        <div class="mb-2">
                            <a-button type="primary" @click="step = 'questionnaire'">
                                {{ $t("revisitQuestionnaire") }}
                            </a-button>
                        </div>
                        <div>
                            <a-button type="primary" @click="finish">
                                {{ $t("acknowledgeStatus") }}
                            </a-button>
                        </div>
                    </div>

                </div>
            </div>
        </k-container>
        <template v-slot:footer>
            <k-footer/>
        </template>
    </k-page>
</template>

<script>
import QuestionnaireForm from '@product-common/components/investor/QuestionnaireForm';
import ProfileHeader from '@investor/components/profile/ProfileHeader';
import OptInAsAccreditedInvestor from "@investor/components/registration/OptInAsAccreditedInvestor";

export default {
    components: {
        OptInAsAccreditedInvestor,
        ProfileHeader,
        QuestionnaireForm
    },
    data() {
        return {
            step: 'intro',
            validation: {
                fieldErrors: {}
            }
        };
    },
    methods: {
        async onSubmit(form) {
            this.validation = {
                fieldErrors: {}
            };
            try {
                const data = await this.$post('registration/submit-investor-questionnaire', form);
                if (data.questionnaireRejected) {
                    this.step = 'rejected'
                } else {
                    this.step = 'accepted'
                }
            } catch (error) {
                console.error(error);
                if (error.response && error.response.status === 400) {
                    this.validation = error.response.data;
                    this.$scrollToErrorField();
                }
            }
        },

        async proceed() {
            this.step = 'questionnaire';
            this.$trackGAEvent('verification', 'verificationContinuation');
        },
        async confirmQuestionnaire() {
            try {
                await this.$post('registration/confirm-investor-questionnaire');
                this.$trackGAEvent('verification', 'verificationInfo');

                this.$trackGAEvent('verification', 'verificationInfoSuccess');

                await this.$fetchInvestorProfile();
                await this.$routeInvestor();
            } catch (error) {
                console.error(error);
                if (error.response && error.response.status === 400) {
                    this.validation = error.response.data;
                    this.$scrollToErrorField();
                }
            }
        }
    }
};
</script>


